import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'parceiras',
  templateUrl: './parceiras.component.html',
  styleUrls: ['./parceiras.component.css']
})
export class ParceirasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
